import { NgModule } from '@angular/core';
import { TabViewModule } from 'primeng/tabview';
import { TabComponent } from './tab.component';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [TabComponent],
  imports: [CommonModule, TabViewModule],
  exports: [TabComponent],
})
export class TabComponentModule {}
